import axios from "axios";

const createInformInstallJobFiles = async (inform) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/InformInstallJobFiles`, inform)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const deleteInformInstallJobFiles = async (id) => {
  return axios
    .delete(`${process.env.REACT_APP_API_URL}/InformInstallJobFiles/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const InformInstallJobFilesService = {
  createInformInstallJobFiles,
  deleteInformInstallJobFiles
};

export default InformInstallJobFilesService;
